var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"timezone-list"},_vm._l((_vm.PhoneCode),function(item,index){return _c('li',{key:index,staticClass:"timezone-single pointer",on:{"click":function($event){return _vm.chooseArea(item)}}},[_vm._v(" "+_vm._s(item.country)+" "),_c('i',[_vm._v("+"+_vm._s(item.area_code))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }